// Mock data for Animal Care India website

export const stats = {
  soulsTouched: 21432,
  animalsRescued: 1891,
  antiRabiesVaccination: 12344,
  waterBowls: 1002,
  volunteersActive:433,
  adoptionsDone: 234
};


export const heroImages = [
  "/team/gallery1.jpg",
  "/team/gallery2.jpg"
];

export const rescueImages = [
  "/newsletters/thumbnail/September.jpeg",
  "/team/gallery2.jpg",
  "/team/gallery3.jpg",
  "/team/rehabilitation.jpg",
  "/hero-images/pawsitiveProtector.png",
  "/team/gallery5.jpg"
];

export const adoptableDogs = [
  {
    id: 1,
    name: "Hope",
    age: "2 years",
    gender: "Female",
    category: "dog",
    temperament: "Friendly, Calm, Good with kids",
    vaccination: true,
    sterilisation: true,
    story: "Hope was found injured on the highway. After months of rehabilitation, she's ready for a loving home.",
    image: "/team/laadli.png"
  },
  {
    id: 2,
    name: "Bruno",
    age: "4 years",
    gender: "Male",
    category: "dog",
    temperament: "Playful, Energetic, Loyal",
    vaccination: true,
    sterilisation: true,
    story: "Bruno is a gentle giant who loves to play fetch and go on long walks.",
    image: "/team/dadu.png"
  },
  {
    id: 3,
    name: "Babli",
    age: "3 months",
    gender: "Female",
    category: "puppy",
    temperament: "Curious, Playful, Affectionate",
    vaccination: true,
    sterilisation: false,
    story: "Babli was rescued from a construction site. She's a bundle of joy looking for a forever home.",
    image: "/team/babli.png"
  },
  {
    id: 4,
    name: "Max",
    age: "1 year",
    gender: "Male",
    category: "dog",
    temperament: "Smart, Trainable, Protective",
    vaccination: true,
    sterilisation: true,
    story: "Max is an intelligent indie dog who learns commands quickly.",
    image: "/team/malu.png"
  },
  {
    id: 5,
    name: "Goldie",
    age: "5 months",
    gender: "Female",
    category: "puppy",
    temperament: "Gentle, Sweet, Calm",
    vaccination: true,
    sterilisation: false,
    story: "Goldie is a sweet puppy who loves cuddles and belly rubs.",
    image: "/team/gopi.png"
  },
  {
    id: 6,
    name: "Rocky",
    age: "6 months",
    gender: "Male",
    category: "puppy",
    temperament: "Adventurous, Brave, Friendly",
    vaccination: true,
    sterilisation: false,
    story: "Rocky was found abandoned in a park. He's now healthy and ready for adoption.",
    image: "/team/browney.png"
  }
];

export const adoptableCats = [
  {
    id: 7,
    name: "Whiskers",
    age: "1 year",
    gender: "Male",
    category: "cat",
    temperament: "Independent, Calm, Loving",
    vaccination: true,
    sterilisation: true,
    story: "Whiskers is a beautiful tabby who loves quiet corners and gentle pets.",
    image: "/team/story1.png"
  },
  {
    id: 8,
    name: "Luna",
    age: "2 years",
    gender: "Female",
    category: "cat",
    temperament: "Playful, Affectionate, Social",
    vaccination: true,
    sterilisation: true,
    story: "Luna is a friendly cat who gets along well with other pets.",
    image: "/team/story2.png"
  },
  {
    id: 9,
    name: "Simba",
    age: "4 months",
    gender: "Male",
    category: "cat",
    temperament: "Curious, Energetic, Cuddly",
    vaccination: true,
    sterilisation: false,
    story: "Simba is a young orange tabby full of energy and love.",
    image: "/team/story3.png"
  }
];

export const newsletters = [
  {
    id: 1,
    title: "Animal Care Newsletter - October 2025",
    date: "October 2025",
    file: "/newsletters/Animal Care Newsletter October 2025.pdf",
    image: rescueImages[0]
  },
  {
    id: 2,
    title: "Animal Care Newsletter - September 2025",
    date: "September 2025",
    file: "/newsletters/Animal Care Newsletter September 2025.pdf",
    image: rescueImages[1]
  },
  {
    id: 3,
    title: "Animal Care Newsletter - June 2025",
    date: "June 2025",
    file: "/newsletters/June Newsletter 2025.pdf",
    image: rescueImages[2]
  },
  {
    id: 4,
    title: "Animal Care Newsletter - May 2025",
    date: "May 2025",
    file: "/newsletters/May Newsletter 2025.pdf",
    image: rescueImages[3]
  },
  {
    id: 5,
    title: "Animal Care Newsletter - April 2025",
    date: "April 2025",
    file: "/newsletters/April Newsletter 2025.pdf",
    image: rescueImages[4]
  }
];

// Legacy export for backward compatibility
export const blogPosts = newsletters;

export const testimonials = [
  {
    id: 1,
    name: "Samiksha Dixit",
    text: "We are truly grateful to the Animal Care Team for their incredible support in vaccinating and deworming all our dogs. Recently, one of our community dogs was badly injured with severe bite wounds. After reaching out to many NGOs without much response, the Animal Care Team responded within half an hour and immediately guided me with a simple and effective process to help the dog."
  },
  {
    id: 2,
    name: "Aakriti Dhawan",
    text: "I've personally worked with Animal Care India, it is amazing how not only do they love the animals but also take immense care of them. They have helped deworm over 500 dogs and put collars to protect them. Special thanks to Mr. Surendra and his team member, you came in extreme weather conditions to help our kids."
  },
  {
    id: 3,
    name: "Vishakha Kapoor",
    text: "All I can say is, this organization restores the faith in humanity! Their selfless work and dedication towards any living being is remarkable. Vikas despite being unwell and Mayur, even though was hurt following a bike accident, worked relentlessly with me to cater medicines and collars to our streeties!"
  },
  {
    id: 4,
    name: "Rashmi Mahajan",
    text: "I had my interaction with Animal Care India when Mr Vikas and his team visited my locality in Sushant Lok I Gurgaon for a vaccination drive. The team arrived on time, was very gentle and very patient and experienced in handling strays. They were young and passionate team and selfless volunteers doing a great service."
  },
  {
    id: 5,
    name: "Prachi Dubey",
    text: "They came to our society for vaccination drive. Very empathetic staff. Doctor was also very compassionate. They waited with us patiently to make sure all dogs get their vaccination."
  },
  {
    id: 6,
    name: "Vishal Mirg",
    text: "I haven't come across a team which is more polite, understanding and compassionate towards furry animals. They helped us in carrying out a vaccination drive effortlessly and the way they handled all the dogs in society is commendable."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dr. Anjali Kumar",
    role: "Founder & Veterinarian",
    image: "/team/founder.jpeg",
    bio: "20+ years of experience in animal welfare and veterinary medicine."
  },
  {
    id: 2,
    name: "Vikram Singh",
    role: "Operations Head",
    image: "/team/trustee.jpeg",
    bio: "Manages rescue operations and volunteer coordination."
  },
  {
    id: 3,
    name: "Meera Patel",
    role: "Adoption Coordinator",
    image: "/team/Monika.png",
    bio: "Ensures every animal finds the perfect forever home."
  }
];

export const donationOptions = [
  {
    id: 1,
    amount: 500,
    impact: "Provides deworming medication and nutritious food for one animal",
    type: "one-time"
  },
  {
    id: 2,
    amount: 1500,
    impact: "Covers emergency first aid and initial treatment",
    type: "one-time"
  },
  {
    id: 3,
    amount: 5000,
    impact: "Supports major surgery and post-operative care",
    type: "one-time"
  },
  {
    id: 4,
    amount: 1000,
    impact: "Monthly support for ongoing rescue operations",
    type: "monthly"
  }
];

export const workCategories = [
  {
    id: 1,
    title: "Animal Rescue & First Aid",
    description: "24/7 emergency response team for injured and distressed street animals",
    icon: "Ambulance",
    stats: "254+ animals rescued",
    image: rescueImages[0]
  },
  {
    id: 2,
    title: "Sterilization under ABC Programme",
    description: "Humane animal birth control to create safer, healthier communities",
    icon: "Scissors",
    stats: "ABC Programme",
    image: rescueImages[2]
  },
  {
    id: 3,
    title: "Rehabilitation & Long-Term Care",
    description: "Comprehensive recovery programs for animals requiring extended treatment",
    icon: "Home",
    stats: "365+ animals in care",
    image: rescueImages[3]
  },
  {
    id: 4,
    title: "Adoption Program",
    description: "Finding loving forever homes for rescued and rehabilitated animals",
    icon: "Users",
    stats: "254+ successful adoptions",
    image: "/team/whity.png"
  },
  {
    id: 5,
    title: "Pawsitive Protectors",
    description: "Reflective collar distribution, vaccination drives, and community deworming programs",
    icon: "Shield",
    stats: "5632 animals protected",
    image: rescueImages[4]
  },
  {
    id: 6,
    title: "Disaster Response",
    description: "Emergency animal rescue during natural calamities and crisis situations",
    icon: "AlertCircle",
    stats: "Fast response nationwide",
    image: rescueImages[5]
  }
];

export const campaignHighlights = [
  {
    id: 1,
    title: "Bowl of Hope",
    tagline: "Every Bowl Can Save a Life",
    icon: "Droplets",
    summary:
      "Every summer, thousands of street animals silently battle dehydration, heatstroke, and exhaustion. Bowl of Hope turns a single bowl into a lifeline for community animals.",
    paragraphs: [
      "Every summer, thousands of street animals silently battle dehydration, heatstroke, and exhaustion. As temperatures soar across our cities, access to clean drinking water becomes a daily struggle for dogs, cats, birds, squirrels, and countless other animals that share our streets.",
      "The Bowl of Hope campaign was born from one simple belief—no living being should suffer because they cannot ask for water.",
      "What began with a handful of water bowls has grown into a community-driven movement spanning Delhi, Gurgaon, and Noida. Today, Animal Care works with schools, hospitals, residential societies, corporate offices, marketplaces, volunteers, and local residents to install and maintain water stations for community animals.",
      "Each bowl represents far more than water. It represents compassion, responsibility, and coexistence. Volunteers and residents regularly refill these bowls, creating a network of care that saves lives throughout the summer months.",
      "Beyond providing relief, Bowl of Hope has inspired thousands of people to become active participants in animal welfare, proving that meaningful change often begins with the smallest acts of kindness."
    ],
    subheading: "Campaign Impact",
    impact: [
      "Water bowls installed across multiple cities",
      "Thousands of animals receive access to clean drinking water daily",
      "Active participation from schools, corporates, RWAs, and volunteers",
      "Increased awareness about caring for community animals"
    ],
    closing: "Together, one bowl can become a lifeline."
  },
  {
    id: 2,
    title: "Pawsitive Protectors",
    tagline: "Protecting Lives Before They Need Rescue",
    icon: "Stethoscope",
    summary:
      "Animal welfare isn't only about rescuing injured animals—it's about preventing suffering before it begins. Pawsitive Protectors brings preventive healthcare to neighborhood animals.",
    paragraphs: [
      "Animal welfare isn't only about rescuing injured animals—it's about preventing suffering before it begins.",
      "Pawsitive Protectors is Animal Care's preventive healthcare initiative dedicated to improving the lives of community animals through vaccination, deworming, and public awareness. Our veterinary teams work directly in neighborhoods across Delhi NCR, reaching animals that may never otherwise receive medical attention.",
      "The campaign focuses on Anti-Rabies Vaccination (ARV), 9-in-1 Vaccination, and Deworming, helping protect animals from preventable diseases while contributing to safer, healthier communities for everyone.",
      "Each drive is carried out with compassion and respect. Working alongside local feeders, volunteers, and residents, our team ensures every intervention is calm, humane, and stress-free for the animals.",
      "Preventive healthcare creates a lasting impact. Every vaccinated dog or cat is one less animal vulnerable to disease, one healthier community member, and one step closer to a future where humans and animals coexist peacefully."
    ],
    subheading: "What We Do",
    impact: [
      "Anti-Rabies Vaccination Drives",
      "9-in-1 Preventive Vaccination",
      "Deworming Programmes",
      "Community Animal Health Assessments",
      "Public Awareness & Humane Education"
    ],
    closing: "Healthy animals create healthier communities."
  },
  {
    id: 3,
    title: "Build Their Tomorrow",
    tagline: "Building More Than a Shelter—Building Hope",
    icon: "Home",
    summary:
      "Every rescue needs a place to heal. Animal Care is building a dedicated shelter and hospital in Sector 78, Gurgaon — a permanent sanctuary for animals who have nowhere else to go.",
    paragraphs: [
      "Every rescue begins with saving a life.",
      "Recovery begins with having a place to heal.",
      "Every day, Animal Care rescues animals suffering from road accidents, abuse, illness, abandonment, and neglect. While emergency treatment saves lives, long-term recovery requires something equally important—a safe place to rest, heal, and rebuild.",
      "That's why Animal Care is developing a dedicated shelter and hospital designed to provide comprehensive care for injured and vulnerable animals.",
      "Located in Sector 78, near Leopard Trail, Gurgaon, the upcoming facility will offer emergency medical treatment, surgery, recovery wards, quarantine areas, rehabilitation spaces, and secure shelter for animals who have nowhere else to go.",
      "Every brick laid brings us closer to creating a permanent sanctuary where compassion meets professional care. Through our Volunteer Build initiative, supporters have already begun contributing their time and effort to help bring this vision to life.",
      "But the journey is far from complete.",
      "The shelter is being built entirely through the generosity of donors, volunteers, CSR partners, and animal lovers who believe every rescued life deserves a second chance."
    ],
    subheading: "Your Support Helps Build",
    impact: [
      "Emergency Rescue Hospital",
      "Surgical & Treatment Facilities",
      "Recovery & Rehabilitation Wards",
      "Safe Shelter for Rescued Animals",
      "Long-term Medical Care Infrastructure"
    ],
    closing:
      "Together, we're not just constructing a building—we're creating a future where every rescued animal has a place to heal, recover, and belong."
  }
];